import { Injectable } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { BookingEducationApi } from '../apis/booking-education/booking-education.api';
import { BookingRehabilitationApi } from '../apis/booking-rehabilitation/booking-rehabilitation.api';
import { BookingServiceApi } from '../apis/booking-service/booking-service.api';
import { BookingStorageEnum } from '../enums/booking.enum';

@Injectable({
  providedIn: 'root',
})
@UntilDestroy()
export class ReusableOrderMethodsService {
  public isLoading: boolean = false;
  protected constructor(
    protected bookingEducationApi: BookingEducationApi,
    protected bookingRehabilitationApi: BookingRehabilitationApi,
    protected bookingServiceApi: BookingServiceApi,
  ) {}

  public pay(itemId: number, type: BookingStorageEnum): void {
    this.isLoading = true;

    const api = this.getApiByType(type);

    api
      .pay(itemId)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: (resp) => {
          this.isLoading = false;
          if (resp.url) {
            window.location.href = resp.url;
          }
        },
        error: () => (this.isLoading = false),
      });
  }

  private getApiByType(type: BookingStorageEnum) {
    switch (type) {
      case 'education':
        return this.bookingEducationApi;
      case 'service':
        return this.bookingServiceApi;
      case 'rehabilitation':
        return this.bookingRehabilitationApi;
      default:
        throw new Error(`Unsupported type: ${type}`);
    }
  }
}
